import React from 'react';
import { arrayOf, shape, string } from 'prop-types';

// Components
import { NoAuthorizationsAvailable } from 'feature/loading-management/shared-components';
import SelfAuthorizationCard from './card/Card';

const CardsList = ({ cards, currentSelectionNameShort, listType }) => {
  // dynamic method for calculating card height
  // const [cardHeight, setCardHeight] = useState(292);
  return cards.length ? (
    cards.map((card, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <SelfAuthorizationCard
        currentSelectionNameShort={currentSelectionNameShort}
        key={card.productAuthorizationId || i}
        listType={listType}
        selfAuthorization={card}
      />
    ))
  ) : (
    <NoAuthorizationsAvailable />
  );
};

CardsList.propTypes = {
  cards: arrayOf(shape({})).isRequired,
  currentSelectionNameShort: string,
  listType: string,
};

CardsList.defaultProps = {
  currentSelectionNameShort: '',
  listType: null,
};

export default CardsList;
